import {
  App,
  Button,
  Card,
  Col,
  Input,
  message,
  Modal,
  Pagination,
  Row,
  Select,
} from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import React, { useCallback, useEffect, useState, useRef } from "react";
import CourseBox from "../../components/CourseBox";
import { useNavigate } from "react-router-dom";
import { COURSE_LIST, COURSE_STATUS, DELETE_COURSE } from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";

function Courses() {
  const Navigate = useNavigate();
  const { notification } = App.useApp();
  const [courses, set_courses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("course_page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    Number(localStorage.getItem("course_page_size")) || 9
  );
  const [total_pages, set_total_pages] = useState("");
  const [total_courses, set_total_courses] = useState(0);
  const [search_field, set_search_field] = useState(
    localStorage.getItem("course_search_field") || "title"
  );

  const [search_query, set_search_query] = useState(
    localStorage.getItem("course_search_query") || ""
  );
  const [isPublished, setIsPublished] = useState({});

  const debounceRef = useRef(null);

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);


  // API call to fetch courses
  const LIST_API = async (
    page = current_page,
    field = search_field,
    query = search_query
  ) => {
    setLoading(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", pageSize);

    if (field === "title") {
      FORM_DATA.append("title", query);
    } else {
      FORM_DATA.append("tag", query);
    }

    const API_CALL = await COURSE_LIST(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_courses(API_CALL.data?.data);
      set_total_courses(API_CALL.data?.total_courses);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
    }

    setLoading(false);
    set_pagination_loader(false);
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("course_page")) || 1,
      localStorage.getItem("course_search_field") || "title",
      localStorage.getItem("course_search_query") || ""
    );
  }, []);

  // Pagination handler
  const pagination_on_change = async (page, size) => {
    localStorage.setItem("course_page", page);
    localStorage.setItem("course_page_size", size);

    setPageSize(size);
    set_pagination_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);

    if (search_field === "title") {
      FORM_DATA.append("title", search_query);
    } else {
      FORM_DATA.append("tag", search_query);
    }

    const API_CALL = await COURSE_LIST(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_courses(API_CALL.data?.data);
      set_total_courses(API_CALL.data?.total_courses);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
    }

    set_pagination_loader(false);
  };

  // Debounced search function


  // Input handler
  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query) {
      localStorage.setItem(
        "course_last_search_page",
        current_page
      );
    }

    set_search_query(value);
    localStorage.setItem(
      "course_search_query",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "course_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        search_field,
        value
      );

    }, 500);
  };

  // Select field change handler
  const handleSelectChange = (value) => {
    set_search_field(value);

    localStorage.setItem(
      "course_search_field",
      value
    );

    set_search_query("");

    localStorage.removeItem(
      "course_search_query"
    );

    LIST_API(
      current_page,
      value,
      ""
    );
  };
  const selectBefore = (
    <Select value={search_field} onChange={handleSelectChange}>
      <Select.Option value="title">Title</Select.Option>
      <Select.Option value="tag">Tags</Select.Option>
    </Select>
  );

  // Publish course
  const publishCourse = async (course_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", course_id);

    try {
      const response = await COURSE_STATUS(FORM_DATA);
      if (response?.status) {
        message.success("Course published successfully!");
        setIsPublished((prev) => ({
          ...prev,
          [course_id]: true,
        }));
        setLoading(true);
        await LIST_API(current_page);
      } else {
        message.error(response?.message || "Failed to publish course");
      }
    } catch (error) {
      console.error("Error publishing course:", error);
      message.error("Something went wrong while publishing");
    }
  };

  // Delete course
  const deleteCourse = async (course_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", course_id);

    try {
      const response = await DELETE_COURSE(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        await LIST_API(current_page);
      } else {
        notification.error({
          message: "Failed",
          description: response?.data?.message,
        });
      }
    } catch (err) {
      console.error("Error deleting course:", err);

      notification.error({
        message: "Failed",
        description: "Something went wrong",
      });
    }
  };

  const openDeleteModal = (course_id) => {
    setSelectedCourseId(course_id);
    setDeleteModal(true);
  };

  return (
    <div className="lms-body">
      <Card>
        <h2>
          Courses
          <Button
            type="primary"
            size="large"
            onClick={() => {
              localStorage.setItem("course_page", current_page);
              Navigate("/add-courses");
            }}
            style={{ marginLeft: "10px", float: "right" }}
          >
            Create Course
          </Button>
        </h2>
        <br />
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={18} lg={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={
                search_field === "title"
                  ? "Search by title"
                  : "Search by tags"
              }
              onChange={handleInput}
              size="large"
              style={{ width: "100%" }}
              value={search_query}
            />
          </Col>
        </Row>

        {loading || pagination_loader ? (
          <CulsightPageLoader />
        ) : (

          <>
            <div className="courses-card" style={{ marginTop: "20px" }}>
              <Row gutter={[30, 40]}>
                {courses?.length > 0 ? (
                  courses.map((items) => (
                    <Col lg={8} md={8} sm={12} xs={24} key={items?.id}>
                      <CourseBox
                        id={btoa(items?.id)}
                        course_title={items?.title}
                        course_image={items?.thumbnail}
                        course_ribbon={items?.ribbon}
                        course_status={items?.status}
                        chapters_count={items?.chapters_count}
                        users_count={items?.users_count}
                        current_page={current_page}
                        publishCourse={() => publishCourse(items?.id)}
                        isPublished={isPublished[items?.id] === true}
                        deleteCourse={() => openDeleteModal(items?.id)} />
                    </Col>
                  ))
                ) : (
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "20px",
                        color: "red",
                        marginTop: "15px",
                      }}
                    >
                      Data Empty
                    </p>
                  </Col>
                )}
              </Row>
            </div>

            {total_pages > 0 ? (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  current={current_page}
                  total={total_courses}
                  pageSize={pageSize}
                  onChange={pagination_on_change}
                  showSizeChanger
                  pageSizeOptions={["9", "18", "27", "36"]}
                />
              </div>
            ) : (
              <div style={{ textAlign: "center", color: "red" }}>
                <h2>No Courses Found</h2>
              </div>
            )}
          </>
        )}
        <Modal
          open={deleteModal}
          footer={null}
          centered
          width={380}
          onCancel={() => setDeleteModal(false)}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>

            <ExclamationCircleFilled
              style={{
                color: "#faad14",
                fontSize: 20,
                marginTop: 4,
              }}
            />

            <div style={{ flex: 1 }}>
              <h3
                style={{
                  margin: 0,
                  marginBottom: 12,
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                Delete Course
              </h3>

              <p style={{ marginBottom: 4 }}>
                This action cannot be undone.
              </p>

              <p style={{ color: "#666", marginBottom: 20 }}>
                Once this course is deleted, it cannot be restored or
                retrieved again.
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 8,
                }}
              >
                <Button onClick={() => setDeleteModal(false)}>
                  Cancel
                </Button>

                <Button
                  danger
                  onClick={async () => {
                    await deleteCourse(selectedCourseId);
                    setDeleteModal(false);
                  }}
                >
                  Delete Permanently
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </Card>
    </div>
  );
}

export default Courses;